import React, { useState } from 'react';
import './ResultsGate.css';

const ResultsGate = ({ strategy, confidence, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const getStrategyLabel = () => {
    const labels = {
      'patent': 'Patent Protection',
      'trade-secret': 'Trade Secret Protection',
      'defensive-publication': 'Defensive Publication',
      'ship-it': 'Focus on Execution'
    };
    return labels[strategy] || 'IP Protection';
  };

  const getConfidenceLabel = () => {
    if (confidence >= 5) return 'Strongly leans toward';
    if (confidence >= 3) return 'Moderately leans toward';
    return 'Slightly leans toward';
  };

  const getNeedlePosition = () => {
    // Position needle on scale from 0-100
    // Patent on right (high confidence = far right)
    if (strategy === 'patent') {
      return 50 + (Math.min(confidence, 10) * 4); // 50-90%
    } else if (strategy === 'trade-secret') {
      return 50 - (Math.min(confidence, 10) * 4); // 10-50%
    }
    return 50; // center for others
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.name || !formData.email || !formData.company) {
      setError('Please fill in all fields');
      return;
    }

    // Basic email validation
    if (!formData.email.includes('@')) {
      setError('Please enter a valid email address');
      return;
    }

    setIsSubmitting(true);
    
    try {
      // Call the parent's submit handler
      await onSubmit(formData);
    } catch (err) {
      setError('Something went wrong. Please try again.');
      setIsSubmitting(false);
    }
  };

  return (
    <div className="results-gate">
      <div className="gate-content">
        <h1 className="gate-title">Your situation leans toward:</h1>
        
        <div className="strategy-preview">
          <h2 className="strategy-name">{getStrategyLabel()}</h2>
          
          <div className="confidence-meter">
            <div className="meter-labels">
              <span>Trade Secret</span>
              <span>Patent</span>
            </div>
            <div className="meter-track">
              <div 
                className="meter-needle" 
                style={{ left: `${getNeedlePosition()}%` }}
              />
            </div>
            <p className="confidence-label">{getConfidenceLabel()} {getStrategyLabel().toLowerCase()}</p>
          </div>
        </div>

        <div className="gate-prompt">
          <p>Want to see what this means for you?</p>
          <p>Get personalized next steps and important considerations for your specific situation.</p>
        </div>

        <form onSubmit={handleSubmit} className="gate-form">
          <div className="form-field">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Jane Smith"
              required
            />
          </div>

          <div className="form-field">
            <label htmlFor="company">Company</label>
            <input
              type="text"
              id="company"
              name="company"
              value={formData.company}
              onChange={handleChange}
              placeholder="Acme Corp"
              required
            />
          </div>

          <div className="form-field">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="jane@acme.com"
              required
            />
          </div>

          {error && <div className="form-error">{error}</div>}

          <button 
            type="submit" 
            className="gate-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Loading...' : 'Get Your Personalized Results'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResultsGate;
